// src/components/ui/TableSkeleton.jsx
import React from "react";

/**
 * Skeleton rows for tables
 * Props:
 * - columns: number (required)
 * - rows: number (default 5)
 */
export const TableSkeleton = ({ columns, rows = 2 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, r) => (
        <tr key={`sk-${r}`}>
          {Array.from({ length: columns }).map((__, c) => (
            <td key={`skc-${r}-${c}`}>
              <div
                className="skeleton"
                style={{
                  height: 12,
                  borderRadius: 6,
                  width: `${60 + ((c * 15) % 30)}%`,
                }}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

// Lightweight CSS injector (call once at app root or within a shell)
export const injectSkeletonStyles = () => {
  if (typeof document === "undefined") return;
  const id = "skeleton-anim-css";
  if (document.getElementById(id)) return;
  const tag = document.createElement("style");
  tag.id = id;
  tag.innerHTML = `
    .skeleton {
        display: inline-block;
        background: linear-gradient(90deg, rgba(255,255,255,0.08) 25%, rgba(255,255,255,0.18) 37%, rgba(255,255,255,0.08) 63%);
        background-size: 400% 100%;
        animation: shimmer 1.4s ease-in-out infinite;
      }
      @keyframes shimmer {
        0% { background-position: 100% 0; }
        100% { background-position: 0 0; }
      }
  `;
  document.head.appendChild(tag);
};
